<div class="confirmDialogWrap">
  <button class="close" mat-button mat-dialog-close type="button" (click)="proceedCancelAction()">
    <mat-icon>close</mat-icon>
  </button>
  <div>
    <h3 mat-dialog-title>Add New Loan Scenario</h3>
    <div mat-dialog-content>Add New Loan Scenario</div>
    <div>
      <form #addMortgageForm="ngForm" [formGroup]="createLoanForm" (ngSubmit)="onSubmit()">
        <div class="mt-4 row align-items-center">
          <mat-form-field class="col-lg-12">
            <input matInput type="number" placeholder="Interest Rate" formControlName="interest" autocomplete="off" />
            <span matSuffix>%</span>
            <mat-error *ngIf="createLoanForm.get('interest').hasError('required')"> Field is required </mat-error>
            <mat-error
              *ngIf="createLoanForm.get('interest').hasError('max') || createLoanForm.get('interest').hasError('min')"
            >
              Enter a rate between 0 to 15
            </mat-error>
          </mat-form-field>
        </div>
        <div class="mt-4 row align-items-center">
          <mat-form-field class="col-lg-6">
            <input matInput type="number" placeholder="Years" formControlName="termYear" autocomplete="off" />

            <mat-error *ngIf="createLoanForm.get('termYear').hasError('required')"> Field is required </mat-error>
            <mat-error
              *ngIf="createLoanForm.get('termYear').hasError('max') || createLoanForm.get('termYear').hasError('min')"
            >
              Enter a year between 0 and 30
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-lg-6">
            <input matInput type="number" placeholder="Month" formControlName="termMonth" autocomplete="off" />

            <mat-error *ngIf="createLoanForm.get('termMonth').hasError('required')"> Field is required </mat-error>
            <mat-error
              *ngIf="createLoanForm.get('termMonth').hasError('max') || createLoanForm.get('termMonth').hasError('min')"
            >
              Enter a Month between 0 to 11
            </mat-error>
          </mat-form-field>
        </div>

        <div class="mt-4 row align-items-center">
          <mat-form-field class="col-lg-12">
            <input
              matInput
              type="number"
              placeholder=" Expected Closing Cost "
              formControlName="closingCost"
              autocomplete="off"
            />
            <span matPrefix class="pr-2">$</span>
          </mat-form-field>
        </div>
        <div mat-dialog-actions class="mb-0">
          <div class="w-100 text-right mt-2">
            <button class="ml-2" mat-flat-button color="primary" type="submit">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
